import hasDiscount from './hasDiscount';
import { isClient } from './isClient';
import isValidHttpUrl from './isValidHttpUrl';

export const hasDeal = (couponText, price) =>
  couponText === 'checkout' && hasDiscount(price.current_price, price.original_price, price.currency);

export const makeValidItemDesc = item_desc => {
  return item_desc.indexOf('<script ') > -1 || item_desc.length > 1000 ? '' : item_desc;
};

export const toCamelCase = string => {
  return string && string.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};

/**
 * @returns {Number} value from 0 to 5
 */
export function getTagGroup(tagId) {
  return tagId % 6;
}

export function getTagGroupMetadata({ tagGroup, tagName, ruleName, tagDescription, t }) {
  switch (tagGroup) {
    case 0: {
      return {
        title: t('app:latestCoupons', { name: ruleName, year: new Date().getFullYear() }),
        description: `Looking for ${tagName}? Get Karma's Exclusive Coupons & Cashback when shopping`,
      };
    }

    case 1: {
      return {
        title: t('app:latestCoupons', { name: tagName, year: new Date().getFullYear() }),
        description: `Get Karma's Exclusive Coupons & Cashback when shopping ${tagName} at ${ruleName}`,
      };
    }

    case 2: {
      return {
        title: t('app:neverPayFullPrice', { name: ruleName }),
        description: `Looking for ${tagName}? Get Karma's Exclusive Coupons & Cashback when shopping`,
      };
    }

    case 3: {
      return {
        title: t('app:neverPayFullPriceForTag', { name: tagName }),
        description: `Get Karma's Exclusive Coupons & Cashback when shopping ${tagName} at ${ruleName}`,
      };
    }

    case 4: {
      return {
        title: t('app:saveMoneyWhenShoppingAt', { name: ruleName }),
        description: `Looking for ${tagName}? Get Karma's Exclusive Coupons & Cashback when shopping`,
      };
    }

    case 5: {
      return {
        title: t('app:saveMoneyWhenShoppingFor', { name: tagName }),
        description: `Get Karma's Exclusive Coupons & Cashback when shopping ${tagName} at ${ruleName}`,
      };
    }

    default: {
      return {
        title: t('app:tagByBrand', { tag: tagName, brand: ruleName }),
        description: makeValidItemDesc(tagDescription) || 'When I find something I want, I save it to Karma!',
      };
    }
  }
}

export const getTagJsonLD = tag => {
  if (tag.id) {
    const json = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      offers: {
        '@type': 'Offer',
        itemCondition: 'http://schema.org/NewCondition',
        seller: {
          '@type': 'Organization',
          name: tag.rule_name,
        },
      },
      url: isClient() ? window.location.href : tag?.tag_url,
    };

    if (tag.item_desc) {
      json.description = tag.item_desc.length > 5000 ? `${tag.item_desc.substring(0, 4995)}...` : tag.item_desc;
    }

    if (tag.name) {
      json.name = tag.name.length > 150 ? `${tag.name.substring(0, 145)}...` : tag.name;
    }

    if (tag.brand) {
      json.brand = {
        '@type': 'Brand',
        name: tag.brand,
      };
    }

    if (isValidHttpUrl(tag.main_img_url)) {
      json.image = tag.main_img_url;
    }

    if (['active', 'removed'].includes(tag.item_status)) {
      if (tag.marker === 'Low In Stock') {
        json.offers.availability = 'http://schema.org/LimitedAvailability';
      } else {
        json.offers.availability = 'http://schema.org/InStock';
      }
    } else if (['out_of_stock', 'removed_out_of_stock'].includes(tag.item_status)) {
      json.offers.availability = 'http://schema.org/OutOfStock';
    } else if (['sold_out', 'removed_sold_out', 'removed_manual'].includes(tag.item_status)) {
      json.offers.availability = 'http://schema.org/SoldOut';
    } else {
      json.offers.availability = 'http://schema.org/InStock';
    }

    if (
      tag.item_status !== 'sold_out' &&
      tag.item_status !== 'removed_sold_out' &&
      tag.price.currency &&
      tag.price.current_price
    ) {
      json.offers.price = tag.price.current_price.full;
      json.offers.priceCurrency = tag.price.currency.name;
    } else {
      json.offers.price = tag.price.original_price.full;
      json.offers.priceCurrency = tag.price.currency.name;
    }

    return JSON.stringify(json);
  }

  return '';
};

export const parseParams = filters => {
  let params = '';

  Object.keys(filters).forEach(filter => {
    let queryParam = '';

    if (Array.isArray(filters[filter])) {
      queryParam = filters[filter].map(filterValue => `${filter}[]=${encodeURIComponent(filterValue)}`.join('&'));
    } else {
      queryParam = `${filter}=${encodeURIComponent(filters[filter])}`;
    }
    if (queryParam && filters[filter]) {
      params += params ? `&${queryParam}` : `?${queryParam}`;
    }
  });

  return params;
};

export const getQueryParams = (queryParams, tagId) => {
  return Object.keys(queryParams).reduce(
    (result, paramName) => {
      if (['tagId', 'tag_id'].includes(paramName) && !queryParams[paramName]) {
        return result;
      }

      return { ...result, [paramName]: encodeURIComponent(queryParams[paramName]) };
    },
    { tag_id: tagId },
  );
};
